export function getPromiseWithResolvers() {
    let resFunc: undefined|((val?: unknown) => void);
    let rejFunc: undefined|((reason?: unknown) => void);
    const p = new Promise((res, rej) => {
        resFunc = res;
        rejFunc = rej
    });
    if (!resFunc || !rejFunc) throw new Error('[getPromiseWithResolvers] promise resolver or reject functions were `undefined`');
    return { promise: p, resolve: resFunc, reject: rejFunc };
}